type berthTariffData = {
  range: string;
  annual: string;
  monthly: string;
  daily: string;
  dropOrPickUp: string;
};

export const validateBerthTariff = (
  data: berthTariffData,
  setError: React.Dispatch<React.SetStateAction<berthTariffData>>
) => {
  let isError = false;
  if (data.range === "") {
    setError((prevState: any) => ({
      ...prevState,
      range: "Please enter loa-m",
    }));
    isError = true;
  }
  if (data.annual === "") {
    setError((prevState: any) => ({
      ...prevState,
      annual: "Please enter annual berth dues",
    }));
    isError = true;
  }
  if (data.monthly === "") {
    setError((prevState: any) => ({
      ...prevState,
      monthly: "Please enter monthly berth dues",
    }));
    isError = true;
  }
  if (data.daily === "") {
    setError((prevState: any) => ({
      ...prevState,
      daily: "Please enter daily berth dues",
    }));
    isError = true;
  }
  if (data.dropOrPickUp === "") {
    setError((prevState: any) => ({
      ...prevState,
      dropOrPickUp: "Please enter drop off/pick up amount",
    }));
    isError = true;
  }
  if (isNaN(Number(data.annual))) {
    setError((prevState: any) => ({
      ...prevState,
      annual: "Please enter price in number only",
    }));
    isError = true;
  }
  if (isNaN(Number(data.monthly))) {
    setError((prevState: any) => ({
      ...prevState,
      monthly: "Please enter price in number only",
    }));
    isError = true;
  }
  if (isNaN(Number(data.daily))) {
    setError((prevState: any) => ({
      ...prevState,
      daily: "Please enter price in number only",
    }));
    isError = true;
  }
  if (isNaN(Number(data.dropOrPickUp))) {
    setError((prevState: any) => ({
      ...prevState,
      dropOrPickUp: "Please enter price in number only",
    }));
    isError = true;
  }
  return isError;
};
